const state = {
  minFontSize: 120,
  maxFontSize: 250,
  chatLog: [
    {
      time: 'mandag d. 24. oktober 1859 kl. 18:14',
      author: 'N. F. S. Grundtvig',
      text: 'Folk der lærer for at leve, har anderledes Hast-Værk end Folk der lever for at lære.'
    }
  ]
}
export default state
